import { ModuleFE_PermissionUser } from './ModuleFE_PermissionUser.js';
export const ModulePackFE_PermissionUser = [ModuleFE_PermissionUser];
//# sourceMappingURL=module-pack.js.map